import { Flex } from '@chakra-ui/react'
import React from 'react'
import { useWatch } from 'react-hook-form'

//UI
import { Textarea } from '@/components/Form'

//Helper

//Constant
import CostBudgetVendorSelection from '../../../components/CostBudgetVendorSelection'
import CollapsibleCard from '@/components/Elements/CollapsibleCard'
import { useCostBudgetAccess } from './CostBudgetAccessProvider'

const PM100Selection = ({ costBudgetIndex }) => {
  const { canEditPM100Technical } = useCostBudgetAccess()

  return (
    <CollapsibleCard title={'PM100 Selection'} defaultIsOpen={true}>
      <Flex gap="5" direction={'column'}>
        <CostBudgetVendorSelection
          costBudgetIndex={costBudgetIndex}
          selectionPath={`sourcing.costBudgets.${costBudgetIndex}.secondTechnicalSelection`}
          selectionLabel={'Technical Selection'}
          canSelectionVendor={canEditPM100Technical}
          canSelectQuotation={canEditPM100Technical}
          canBeReference={false}
          hasRemark={false}
        />

        <Flex px="2">
          <Textarea
            name={`sourcing.costBudgets.${costBudgetIndex}.secondTechnicalSelection.remark`}
            label={'Vendor Evaluation Checklist'}
            disabled={!canEditPM100Technical}
          />
        </Flex>
      </Flex>
    </CollapsibleCard>
  )
}

export default PM100Selection
